import {
  IDestinationEntityHandler,
  type IDestination,
} from '@principle-theorem/practice-migrations/interfaces';
import { BaseDestinationHandler } from '../destination/base-destination-handler';
import { ContactDestinationEntity } from './destination/entities/contact';
import { PatientDestinationEntity } from './destination/entities/patient';
import { PatientAppointmentDestinationEntity } from './destination/entities/patient-appointments';
import { PatientClinicalChartDestinationEntity } from './destination/entities/patient-clinical-charts';
import { PatientClinicalNoteDestinationEntity } from './destination/entities/patient-clinical-notes';
import { PatientDocumentDestinationEntity } from './destination/entities/patient-documents';
import { PatientMedicalHistoryDocumentsDestinationEntity } from './destination/entities/patient-medical-history-documents';
import { PatientInteractionsDestinationEntity } from './destination/entities/patient-interactions';
import { PatientInvoicesDestinationEntity } from './destination/entities/patient-invoices';
import { PatientTreatmentPlanDestinationEntity } from './destination/entities/patient-treatment-plans';
import { PatientXraysDestinationEntity } from './destination/entities/patient-xrays';
import { StafferDestinationEntity } from './destination/entities/staff';
import { ExistingPatientDestinationEntity } from './destination/entities/existing-patients';
import { PatientRelationshipDestinationEntity } from './destination/entities/patient-relationships';

export const EXACT_DESTINATION: IDestination = {
  metadata: {
    name: 'Principle Firestore',
    description: 'Main Principle Migration',
  },
  configuration: [],
};

export class ExactDestinationHandler extends BaseDestinationHandler {
  migrationType = 'Exact';
  migrationVersion = 'v1';
  destination = EXACT_DESTINATION;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entityHandlers: IDestinationEntityHandler<any, any, any>[] = [
    new PatientDestinationEntity(),
    new StafferDestinationEntity(),
    new ContactDestinationEntity(),
    new PatientInteractionsDestinationEntity(),
    new PatientAppointmentDestinationEntity(),
    new PatientTreatmentPlanDestinationEntity(),
    new PatientClinicalNoteDestinationEntity(),
    new PatientClinicalChartDestinationEntity(),
    new PatientInvoicesDestinationEntity(),
    new PatientDocumentDestinationEntity(),
    new PatientMedicalHistoryDocumentsDestinationEntity(),
    new PatientXraysDestinationEntity(),
    new ExistingPatientDestinationEntity(),
    new PatientRelationshipDestinationEntity(),
  ];
}
